import * as React from 'react';
import { ContentfulImage } from '../ContentfulImage/ContentfulImage.esm.js';

var WrappedImage = function (_a) {
    var _b = _a.fields, asset = _b.asset, imageAnimation = _b.imageAnimation, textAlternative = _b.textAlternative, classes = _a.classes, onLoad = _a.onLoad, maxImageWidth = _a.maxImageWidth;
    return (React.createElement(ContentfulImage, { alt: textAlternative, asset: asset, classes: classes, imageAnimation: imageAnimation, maxImageWidth: maxImageWidth, onLoad: onLoad }));
};

export { WrappedImage as default };
//# sourceMappingURL=WrappedImage.esm.js.map
